import React from 'react';
import { BackArrowSVG  } from '../../Video/Icons';
import stylesRefPend from './style.module.css';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';


type RefPendProps = {
  sticky?: boolean;
  title?: string;
  bgcolor?: string;
}

const RefPendHeader: React.FC<RefPendProps> = ({sticky = false, title, bgcolor="rgba(242, 244, 245, 1)"}) => {

  
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleRedirectBack = () => {
    navigate(-1);
  }


  return (
     <>
    <div className={clsx(stylesRefPend['refpend-header'], sticky ? stylesRefPend.sticky : "")} style={{backgroundColor: bgcolor}}>
      <div className={clsx(stylesRefPend.left)}>
        <span className={stylesRefPend['back-arrow']} onClick={handleRedirectBack}><BackArrowSVG width={12} height={17} /></span> 
        <span className={stylesRefPend.title}>{title ? title : t('myRefPends')}</span>
      </div>
    
    </div>
    </>
  )
}

export default RefPendHeader;